import * as React from 'react'

import { Small, SmartImage } from 'main/ui'
import { Container, ImageContainer, imageSize } from './Achievement.styles'

interface IProps {
  label: string
  imageUrl: string
}

export default function Achievement(props: IProps) {
  const { label, imageUrl } = props

  return (
    <Container>
      <ImageContainer>
        <SmartImage
          height={imageSize}
          width={imageSize}
          src={imageUrl}
          uploadcareTransformations={[]}
        />
      </ImageContainer>
      <Small muted>{label}</Small>
    </Container>
  )
}
